module.exports = __webpack_public_path__ + "img/1.66f5621e.png";